<template>
  <div id="header">
    <div class="header-logo">
      <img src="../assets/pc/logo.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style lang="scss" scoped>
#header{
  height: 60px;
  background: #242424;
  display: flex;
  justify-content: center;
  align-items: center;
  .header-logo{
    width: 976px;
    img{
      width: 132px;
      height: 36px;
      object-fit: contain;
    }
  }
}
</style>
